(function attachSharproHomepage(globalObject) {
  'use strict';

  function createAutoCarousel(options) {
    const {
      slideCount,
      activate,
      intervalMs = 3000,
      reducedMotion = false,
      schedule = globalObject.setInterval
        ? globalObject.setInterval.bind(globalObject)
        : null,
      cancel = globalObject.clearInterval
        ? globalObject.clearInterval.bind(globalObject)
        : null,
    } = options;

    let activeIndex = 0;
    let timer = null;

    function stop() {
      if (timer !== null && cancel) {
        cancel(timer);
      }
      timer = null;
    }

    function start() {
      stop();
      if (reducedMotion || slideCount < 2 || !schedule) return;

      timer = schedule(() => {
        activeIndex = (activeIndex + 1) % slideCount;
        activate(activeIndex);
      }, intervalMs);
    }

    function select(index) {
      if (slideCount < 1) return;
      activeIndex = Math.max(0, Math.min(index, slideCount - 1));
      activate(activeIndex);
    }

    return { start, stop, select };
  }

  const api = { createAutoCarousel };

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = api;
  }

  globalObject.SHARPROHomepage = api;
})(typeof window !== 'undefined' ? window : globalThis);
